'use client';

import React, { Fragment } from 'react';

//
// Global
// --------------------------------------------------
import Global from "../../styles/global-styles.mjs";
export var GlobalStyles = function GlobalStyles() {
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Global, null));
};